import { useOptionalDependency } from 'ditox-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { INTERCOM_MANAGER_TOKEN } from '@/container';
import useGroups from '@/hooks/contacts/use-groups';
import { useConversationSessionStore } from '@/stores/conversation-session';
import { useMessageStore } from '@/stores/message';
import { addToast } from '@/stores/toast';
import { ensureAllSessions, getAllSessions } from '@/utils/cache-session';
import { generateSessionKey } from '@/utils/session';

export default function useClearAllDeviceSession() {
  const { hideAllCurrentSessions } = useConversationSessionStore();
  const intercomManager = useOptionalDependency(INTERCOM_MANAGER_TOKEN);
  const { groups } = useGroups();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { t } = useTranslation();

  const clearAllDeviceSession = async () => {
    try {
      setIsLoading(true);
      for (const session of getAllSessions()) {
        await useMessageStore.getState().hideAll(session.SessionType, session.ID);
        if (session.SessionType === 'group') {
          const group = groups[session.ID];
          if (group?.Info) {
            useConversationSessionStore
              .getState()
              .setLastReadNotice(generateSessionKey('group', session.ID), group.Info);
          }
        }
      }
      hideAllCurrentSessions();
      addToast({
        type: 'success',
        message: t('messaging-settings.success'),
      });
      intercomManager?.dispatch({
        event: 'clear-all-device-session',
      });
    } catch (error: unknown) {
      addToast({
        type: 'error',
        message: t('messaging-settings.failed'),
      });
      setError(error as string);
    } finally {
      setIsLoading(false);
    }
  };

  return { clearAllDeviceSession, isLoading, error };
}
